module.exports = __webpack_public_path__ + "img/haas.b46b6b66.jpg";